import {Component, Input, OnInit} from '@angular/core';
import {FileService} from "../../providers/file.service";
import {ModalController} from "@ionic/angular";
import {AppStateService} from "../../providers/app-state.service";
import {CommonUtils} from "../../utils/common";
import {take} from "rxjs/operators";
import {VImage} from "../../models/vet-clinic.model";
import {FullPictureComponent} from "../full-picture/full-picture.component";

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss'],
})
export class GalleryComponent implements OnInit {


  @Input() vClientUUID: string;
  @Input() type: string;
  @Input() isAdmin: boolean;

  @Input()
  picturesSelected: VImage[];

  multiple: boolean = false;
  accept: string = 'image/jpeg,image/jpg,image/png';
  isBusy: boolean;
  imgs: VImage[];
  activeSegment: 'gallery' | 'upload' = 'gallery';
  hasUnsavedChanges: boolean = false;

  constructor(
    private fileService: FileService,
    private modalController: ModalController,
    private appStateService: AppStateService,
    public commonUtils: CommonUtils
  ) {
  }

  ngOnInit() {
    this.appStateService.isBusySubject.subscribe(e => {
      this.isBusy = e;
    })
    this.getImages()
  }

  onDrop(event) {
    if (event && event.addedFiles) {
      this.appStateService.updateIsBusySubject(true);
      event.addedFiles.forEach(file => {
        this.fileService.uploadFileToCdn(this.vClientUUID, null,'articles', file).pipe(take(1)).subscribe(uploadedVImage => {
          this.appStateService.updateIsBusySubject(false);
          this.getImages();
          this.activeSegment = 'gallery';
        }, error => {
          this.appStateService.updateIsBusySubject(false);
        })
      })
    }
  }

  getImages() {
    this.fileService.getImagesForArticles(this.vClientUUID).subscribe(imgs => {
      if (imgs) {
        this.imgs = imgs.map(e => {
          if (this.picturesSelected?.filter(ps => ps?.uuid === e.uuid).length === 1) {
            e.galleryIncluded = true;
          }
          return e;
        });
        this.imgs = imgs;
      }
      this.appStateService.updateIsBusySubject(false);
    }, error => {
      this.appStateService.updateIsBusySubject(false);
    })
  }

  progress(event: ProgressEvent) {
    console.log(event)
  }

  onClose() {
    if (!this.isBusy) {
      if(this.type === 'articles'){
        let question = 'Czy chcesz zamknąć galerię?';
        if (this.hasUnsavedChanges) {
          question = question + ' W celu utrwalenia zmian zapisz edytowany artykuł.';
        }
        this.commonUtils.presentYesNoActionSheet(question, 'Tak', 'Nie', 'checkmark', 'close', () => {
          this.modalController.dismiss(this.picturesSelected).then(() => {
          })
        }, () => {
        })
      } else if (this.type === 'add-article-picture') {
        let question = 'Czy rezygnujesz z dodania zdjęcia do treści?';
        this.commonUtils.presentYesNoActionSheet(question, 'Tak', 'Nie', 'checkmark', 'close', () => {
          this.modalController.dismiss(null).then(() => {
          })
        }, () => {
        });
      } else {
        let question = 'Czy rezygnujesz z ustawienia artykułu jako promowany?';
        this.commonUtils.presentYesNoActionSheet(question, 'Tak', 'Nie', 'checkmark', 'close', () => {
          this.modalController.dismiss(null).then(() => {
          })
        }, () => {
        });
      }
    }
  }

  segmentChanged($event) {
    this.activeSegment = $event.detail.value;
  }

  getUrl(picture: VImage) {
    return this.commonUtils.getCloudVImageUrlPath(picture.imageFolder, picture.mFolderUUID, '640', picture);
  }

  deleteImage(picture: VImage) {

  }

  async actionOnPicture(picture: VImage){
    if(this.type ==='articles'){
      await this.showPicture(picture)
    } else {
      this.imgs?.forEach(e=>{
        e.galleryIncluded= false;
      });
      this.picturesSelected?.forEach(e=>{
        e.galleryIncluded= false;
      });
      picture.galleryIncluded = true;
      this.picturesSelected = [picture];
      this.hasUnsavedChanges=true;
      if (this.type !== 'promotion' && this.type !== 'main') {
        this.onAddPictureToArticle();
      }
      if(this.type === 'main') {
        this.onUsePicture()
      }
    }
  }

  async showPicture(picture: VImage) {
    const modal = await this.modalController.create({
      component: FullPictureComponent,
      componentProps: {
        'vClientUUID': this.vClientUUID,
        'vImage': picture,
        'canDelete': this.isAdmin
      }
    });

    modal.onDidDismiss().then((dismissData) => {
      if (dismissData?.data) {
        let img = dismissData.data as VImage;
        if (img.galleryIncluded) {
          if (!this.picturesSelected) {
            this.picturesSelected = [];
          }
          if (this.picturesSelected.filter(e => e.uuid === img.uuid).length === 0) {
            this.picturesSelected.push(dismissData.data)
            this.hasUnsavedChanges=true;
          }
        } else {
          if (this.picturesSelected && this.picturesSelected.filter(e => e.uuid === img.uuid).length === 1) {
            this.picturesSelected = this.picturesSelected.filter(e => e.uuid !== img.uuid)
            this.hasUnsavedChanges=true;
          }
        }
      }
    });

    return await modal.present();
  }


  getColorOfCard(picture: VImage) {
    if (picture.galleryIncluded) {
      return 'success';
    } else {
      return 'white';
    }
  }

  onPromoteArticle() {
    if(this.picturesSelected && this.picturesSelected.length > 0 && this.picturesSelected.filter(e=>e.galleryIncluded).length > 0 ){
      let question = 'Czy chcesz ustawić zdjęcie jako promowane w artykule?';
      this.commonUtils.presentYesNoActionSheet(question, 'Tak', 'Nie', 'checkmark', 'close', () => {
        console.log(this.picturesSelected.filter(e=>e.galleryIncluded));
        this.modalController.dismiss(this.picturesSelected.filter(e=>e.galleryIncluded)[0]).then(() => {
        })
      }, () => {
        this.commonUtils.presentYesNoActionSheet('Czy rezygnujesz z ustawienia artykułu jako promowany?', 'Tak', 'Nie', 'checkmark', 'close', () => {
          this.modalController.dismiss(null).then(() => {
          })
        }, () => {
        });
      });
    }
  }

  onUsePicture() {
    if(this.picturesSelected && this.picturesSelected.length > 0 && this.picturesSelected.filter(e=>e.galleryIncluded).length > 0 ){
      let question = 'Czy chcesz ustawić zdjęcie jako główne w artykule?';
      this.commonUtils.presentYesNoActionSheet(question, 'Tak', 'Nie', 'checkmark', 'close', () => {
        console.log(this.picturesSelected.filter(e=>e.galleryIncluded));
        this.modalController.dismiss(this.picturesSelected.filter(e=>e.galleryIncluded)[0]).then(() => {
        })
      }, () => {
      });
    }
  }

  isDisabledArticlePromotionWithPicture(){
    return !(this.picturesSelected && this.picturesSelected.length > 0 && this.picturesSelected.filter(e=>e.galleryIncluded).length > 0);
  }

  onAddPictureToArticle() {
    this.modalController.dismiss(this.picturesSelected.filter(e=>e.galleryIncluded)[0]).then(() => {
    })
  }
}
